document.addEventListener('DOMContentLoaded', function() {
  const copyButton = document.querySelector('.js-Copy');

  if (copyButton) {
      copyButton.addEventListener('click', function() {
          navigator.clipboard.writeText(copyButton.getAttribute('data-copy')).then(function() {
              alert('Odkaz byl zkopírován!');
          }).catch(function(err) {

          });
      });
  }
});
